<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("projects") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("date range") }}</label>
          <generic-calendar
            type="date"
            :is_range="true"
            ref="generic_calendar"
            @selected="date_changed"
          />
        </div>
      </div>
      <!-- <div class="column">
        <div class="field">
          <label class="label">{{ $t("source") }}</label>
          <div class="control">
            <div class="select">
              <select v-model="meta.source">
                <option
                  :value="source.url_name"
                  v-for="(source, sidx) in sources"
                >
                  {{ source.establishment }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div> -->
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="title is-5">{{ $t("projects") }}</div>
      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li
            @click="change_active_tab($event, this)"
            :data-tab="grp.status"
            v-for="(grp, gidx) in grouped"
            :key="gidx"
            v-bind:class="{ 'is-active': gidx == 0 }"
          >
            <a>
              <i class="check icon" aria-hidden="true"></i>
              <span>{{ $t(grp.status) }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="is-fluid" ref="contents">
        <div
          v-bind:class="{ 'is-active': gidx == 0, 'is-hidden': gidx != 0 }"
          :data-tab="grp.status"
          v-for="(grp, gidx) in grouped"
          :key="gidx"
        >
          <div class="content">
            <ul>
              <li v-for="(prj, pidx) in grp.projects" :key="pidx">
                <div class="title is-5">{{ prj.name }}</div>
                <div class="subtitle is-5">
                  {{ $t(prj.type) }} {{ $t("for") }} {{ prj.settings.customer }}
                </div>
                <div class="subtitle is-5">
                  <pre>{{ prj }}</pre>
                </div>
              </li>
            </ul>
          </div>
          <!-- <pre>{{ grp.projects }}</pre> -->
        </div>
      </div>
      <!-- <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("data") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(itm, spidx) in projects" :key="spidx">
            <td>
              <pre>{{ itm }}</pre>
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- <pre>{{ grouped }}</pre> -->
      <!-- </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  change_active_tab,
  format_time,
  format_currency,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import { groupBy } from "lodash";

export default {
  name: "OrdersReport",
  components: { GenericTable, GenericCalendar },
  data() {
    let v = this;
    return {
      projects: [],
      meta: {
        start_date: "",
        end_date: "",
      },
    };
  },
  computed: {
    grouped() {
      let grouped = groupBy(this.projects, (prj) => {
        return prj.status;
      });

      let grpd = Object.keys(grouped).map((key) => {
        return {
          status: key,
          projects: grouped[key],
        };
      });

      return grpd;
    },
  },
  methods: {
    change_active_tab,
    format_date_time,
    format_time,
    format_currency,
    query() {
      let v = this;
      get("/apis/air_project/date-range", v.meta)
        .then((r) => {
          v.projects = r;
          // console.log(r);
        })
        .catch((error) => {
          error_message(error);
        });
    },
    date_changed(date) {
      let v = this;
      v.meta.start_date = date.start_date;
      v.meta.end_date = date.end_date;
    },
  },
  mounted() {
    // let v = this;
    // get("/apis/order/sources", {})
    //   .then((r) => {
    //     v.sources = r;
    //   })
    //   .catch((error) => {
    //     error_message(error);
    //   });
  },
};
</script>

<style>
/* Add Bulma styles here */
</style>
